module.exports = __webpack_public_path__ + "static/media/customize.54eb82b5.jpg";